// @flow

export type TMerchantProviderIDs = {
  plaid: Array<string>,
  mx: Array<string>,
  finicity: Array<string>,
};

export type TMerchantOptions = {
  mch_id: string,
  parent_name: string,
  name: string,
  logo: ?string,
  description: ?string,
  note: ?string,
  types: Array<string>,
  account_prefixes: Array<string>,
  provider_ids: TMerchantProviderIDs,
};

export default class Merchant {
  mch_id: string;
  parent_name: string;
  name: string;
  logo: ?string;
  description: ?string;
  note: ?string;
  types: Array<string>;
  account_prefixes: Array<string>;
  provider_ids: TMerchantProviderIDs;

  constructor(options: TMerchantOptions) {
    this.mch_id = options.mch_id;
    this.parent_name = options.parent_name;
    this.name = options.name;
    this.logo = options.logo;
    this.description = options.description;
    this.note = options.note;
    this.types = options.types;
    this.account_prefixes = options.account_prefixes;
    this.provider_ids = options.provider_ids;
  }

  static init(options: TMerchantOptions): Merchant {
    return new Merchant(options);
  }

  hasPrefixForNumber(accountNumber: string): boolean {
    if (accountNumber.trim() === '') return false;
    return this.account_prefixes.some(prefix => accountNumber.startsWith(prefix));
  }

  isTypeCC(): boolean {
    return this.types.length === 1 && this.types[0] === 'credit_card';
  }

  getPresentableInputPrompt(mask: ?string): string {
    const type = this.types[0];
    if (this.types.length === 1) {
      if (type === 'credit_card') return mask
        ? `Provide the remaining digits for your credit card ending in ${mask}`
        : 'Enter your credit card number';
    }

    return mask
      ? `Provide the remaining digits for your account number ending in ${mask}`
      : 'Enter your account number';
  }
}
